<script>
export default {
  name: "BaseControl",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: [String, Boolean],
      required: true
    },
    v: {
      type: Object,
      default: null
    },
    error: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: this.value
    };
  },
  computed: {
    hasError() {
      return !!this.error;
    },
    classes() {
      return {
        "is-invalid": this.hasError
      };
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = newValue;
      }
    }
  },
  methods: {
    emitEvent(event) {
      this.$emit("input", event.target ? event.target.value : event);
      this.vTouch();
    },
    emitKeydown(event) {
      this.$emit("keydown", event);
      this.vTouch();
    },
    emitChange(event) {
      this.$emit("change", event.target ? event.target.value : event);
      this.vTouch();
    },
    vTouch() {
      this.v && this.v.$touch();
    }
  }
};
</script>

<style lang="scss"></style>
